import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button } from '@mui/material';

import GeneralAction from '../panel/generalAction';



export default function PublicationTable(props) {



    // console.log(props, 'props');
    return (
        <div className='py-3'>
            <div className="row">
                <div className='py-3'>
                    <Button variant='contained' color='error' fullWidth>{props.school && props.school.schoolName}</Button>
                </div>
            </div>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead sx={{ backgroundColor: 'black' }}>
                        <TableRow>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }}>Sl no</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }}>Title</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Date</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Image</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} align="right">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.publication?.map((row, index) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell >{index + 1} </TableCell>
                                <TableCell >{row.title} </TableCell>
                                <TableCell >{row.date} </TableCell>
                                <TableCell >
                                    <img src={`${process.env.REACT_APP_BACKEND}publication/${row.image}`} height={50} />
                                </TableCell>
                                <TableCell align="right">
                                    <Button size='small'>
                                        <GeneralAction data={row}  handleClickOpen={props.handleClickOpen} setModalData={props.setModalData} />
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </div>
    );
}